import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { request } from '../../service/request.js';
import { getFirstPartyTrafficIdentity } from '../../service/firstPartyTrafficIdentity.js';

export const FirstPartyPageview = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const pagePath = `${location.pathname}${location.search || ''}`;
    if (window.__nettgravLastBackendPageviewKey === pagePath) return;

    window.__nettgravLastBackendPageviewKey = pagePath;
    const identity = getFirstPartyTrafficIdentity();
    request(
      '/page_views',
      {
        hostname: window.location.hostname,
        path: pagePath,
        referrer: document.referrer,
        visitor_id: identity?.visitorId,
        session_id: identity?.sessionId,
      },
      'post',
    ).catch(() => {});
  }, [location.pathname, location.search]);

  return null;
};

export default FirstPartyPageview;
